import { useReducer } from 'react';
import ShopContext from './shop-context';
import shopReducer from './shopReducer';

const getDefaultShopState = () => {
  const shop = localStorage.getItem('shop');
  const delivery_data = localStorage.getItem('delivery_data');
  return {
    shop: shop ? JSON.parse(shop) : {},
    delivery_data: delivery_data ? JSON.parse(delivery_data) : {},
  }
}

const ShopProvider = ({ children }) => {
  // Used as a wrapper component to provide state access to children
  const [shopState, dispatchShop] = useReducer(shopReducer, getDefaultShopState());

  // Actions Dispatch to the Reducer
  const onSetShop = (data) => {
    dispatchShop({ type: 'SET_SHOP', payload: data });
  };

  const onSetDeliveryData = (data) => {
    dispatchShop({ type: 'SET_DELIVERY_DATA', payload: data });
  };

  // default cart context
  const shopContext = {
    shop: shopState.shop,
    delivery_data: shopState.delivery_data,
    setShop: onSetShop,
    setDeliveryData: onSetDeliveryData,
  };

  return (
    <ShopContext.Provider value={shopContext}>{children}</ShopContext.Provider>
  );
};

export default ShopProvider;
